export const RENEWAL_NOTIFICATION_KEY = 'renewal'
export const RENEWAL_MESSAGE =
  'We’ve upgraded your notification experience! To continue receiving important updates seamlessly, you’ll need to sign this message on every chain you use.'
